import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueGtag from "vue-gtag";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import SystemConst from "@/config/const";
import FirebaseApp from "@/firebase/firebase";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
library.add(fas, far);

FirebaseApp.init();

Vue.config.productionTip = false;

Vue.use(VueGtag, {
  config: { 
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_KEY,
    params: { send_page_view: true}
  }
});

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.filter("priceSeparate", function(value: number): string | null {
  if (!value) {
    return "0";
  }
  const realValue = Math.floor(value * SystemConst.CONSUMPTION_TAX);
  return String(realValue).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
});

Vue.filter("purchasedPriceSeparate", function(value: number): string | null {
  if (!value) {
    return "0";
  }
  const realValue = Math.floor(value);
  return String(realValue).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
